import React from "react";
import { AlertTriangle, ArrowLeft, RotateCw } from "lucide-react";

class MentorRouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Mentor LMS route render failed", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="mentor-route-error" role="alert">
        <span className="mentor-route-error__icon"><AlertTriangle size={24} /></span>
        <p>MENTOR WORKSPACE</p>
        <h1>This page could not be displayed</h1>
        <span>Your session is safe. Reload this page, or return to the previous screen.</span>
        <div>
          <button type="button" className="mentor-btn-primary" onClick={() => window.location.reload()}>
            <RotateCw size={15} /> Reload page
          </button>
          <button type="button" className="mentor-btn-secondary" onClick={() => window.history.back()}>
            <ArrowLeft size={15} /> Go back
          </button>
        </div>
      </main>
    );
  }
}

export default MentorRouteErrorBoundary;
